import { CustomFormFieldSelect } from '@src/@data/types/customForms';
import { useMemo } from 'react';
import Select from 'react-select';
import { FormGroup, Label } from 'reactstrap';

interface CustomFormSelectFieldProps {
  field: CustomFormFieldSelect;
  inputName: string;
  value?: string;
  onChangeField: (value: string) => void;
}

export const CustomFormSelectField: React.FC<CustomFormSelectFieldProps> = ({
  field,
  inputName,
  value,
  onChangeField,
}) => {
  const options = useMemo(() => {
    return field.options.map((option) => ({ label: option, value: option }));
  }, [field.options]);

  return (
    <FormGroup>
      <Label for={inputName}>{field.name}</Label>
      <Select
        value={value ? { label: value, value } : undefined}
        options={options}
        onChange={(newValue) => {
          onChangeField(newValue?.value ?? '');
        }}
        inputId={inputName}
        placeholder={''}
        openMenuOnFocus
        isSearchable={false}
        isClearable
        menuPlacement="top"
      />
    </FormGroup>
  );
};
